import { SET_USERS } from "../actions/usersActions";

const initialState: UsersState = {
    users: []
}

const usersReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_USERS:
            return {
                ...state,
                users: action.value
            }
       
        default:
            return state;
    }
}

export interface UsersState {
    users: any[];
}

export default usersReducer;